import React from 'react';
import ActiveBanner from './ActiveBanner';
import { useConnect } from '../../../../hooks/@lore/query-connect';
import useMissingFields from '../../../pages/event-manage/useMissingFields';
import DraftBanner from './DraftBanner';
import CompletedBanner from './CompletedBanner';
import CancelledBanner from './CancelledBanner';
import ExpiredBanner from './ExpiredBanner';
import { DateTime } from 'luxon';
import { getTimestampDiff } from '../../../utils/dateTimeUtils';

export default function Banner(props) {
  const { event } = props;

  const { missingFields } = useMissingFields(event);

  const creator = useConnect('user.byId', {
    id: event.data.creatorId
  });

  // return (
  //   <>
  //     <ActiveBanner
  //       event={event}
  //       creator={creator}
  //     />
  //     <DraftBanner
  //       event={event}
  //       creator={creator}
  //     />
  //     <CompletedBanner
  //       event={event}
  //       creator={creator}
  //     />
  //     <CancelledBanner
  //       event={event}
  //       creator={creator}
  //     />
  //     <ExpiredBanner
  //       event={event}
  //       creator={creator}
  //     />
  //   </>
  // );

  if (event.data.completed) {
    return (
      <CompletedBanner
        event={event}
        creator={creator}
      />
    );
  }

  if (event.data.cancelled) {
    return (
      <CancelledBanner
        event={event}
        creator={creator}
      />
    );
  }

  if (missingFields.data.length > 0) {
    return (
      <DraftBanner
        event={event}
        creator={creator}
      />
    );
  }

  const diff = getTimestampDiff(DateTime.now().toISO(), event.data.endDate);

  if (diff > 0) {
    return (
      <ExpiredBanner
        event={event}
        creator={creator}
      />
    );
  }

  return (
    <ActiveBanner
      event={event}
      creator={creator}
    />
  );
};
